import { Rule } from "../interfaces/RuleInterface";

export const RULE_INITIAL_VALUES: Rule = {
   profiles: [],
   description: "",
}